const lightboxInit = (gallery) => {
  const lightboxes = document.querySelectorAll<HTMLElement>(".lightbox-popup");

  [...lightboxes].forEach((lightbox: HTMLElement) => {
    const lightboxCloseIcon = lightbox.querySelector(".lightbox-popup__close");
    const lightboxId = lightbox.dataset?.attribute as string;
    const lightboxOpen = document.querySelector(
      `.contained--slide[data-attribute="${lightboxId}"]`
    );

    const handleLightbox = () => {
      lightbox.classList.toggle("lightbox-popup--active");
    };

    if (lightboxCloseIcon && lightboxOpen) {
      lightboxOpen.addEventListener("click", () => {
        handleLightbox();
      });

      lightboxCloseIcon.addEventListener("click", () => {
        handleLightbox();
      });
    }
  });
};

export default lightboxInit;
